import React from "react";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdateTeamDetail from '../../components/admincomponents/UpdateTeamDetail';

function UpdateTeam({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdateTeamDetail />            
    </>
  );
}

export default UpdateTeam;
